module.exports = __webpack_public_path__ + "img/274.687f13a0.png";